<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>退出资源列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 查询 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="录入时间" label-width="80px">
          <el-date-picker
            v-model="query.daterange"
            @change="datelClick()"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="退出时间" label-width="80px">
          <el-date-picker
            v-model="query.quitRange"
            @change="selList()"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="类型" label-width="60px">
          <el-select v-model="query.enrolType" clearable placeholder="请选择" @change="selList()">
            <el-option label="新报" value="新报"></el-option>
            <el-option label="续费" value="续费"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="营销" label-width="80px" v-if="userIsAdmain">
          <el-select
            v-model="query.marketID"
            clearable
            placeholder="请选择营销老师"
            @change="datelClick()"
          >
            <el-option
              v-for="item in marketlist"
              :label="item.realName"
              :value="item.userID"
              :key="item.userID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历" label-width="60px">
          <el-select v-model="query.eduBack" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地" label-width="70px">
          <el-select v-model="query.province" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in provinceList" :label="item.areaName" :value="item.areaName" :key="item.areaID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生/家长" label-width="80px">
          <el-select v-model="query.studentType" clearable placeholder="请选择" @change="selList()">
            <el-option v-for="item in studentTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学习目的" label-width="80px">
          <el-select v-model="query.purpose" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in purposeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上课形式" label-width="80px">
          <el-select v-model="query.intendedForm" clearable placeholder="请选择" @change="selList()">
            <el-option v-for="item in intendedFormList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="exportClick()">导出</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>退出资源列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="quitTime" label="退出时间"></el-table-column>
          <el-table-column prop="payTime" label="缴费时间"></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="eduBack" label="学历"></el-table-column>
          <el-table-column prop="enrolType" label="类型" width="70"></el-table-column>
          <el-table-column prop="classForm" label="上课形式"></el-table-column>
          <el-table-column prop="areaShow" label="地区"></el-table-column>
          <el-table-column prop="abroadDate" label="赴日时间" :width="100"></el-table-column>
          <el-table-column prop="refundtime" label="退费课时"></el-table-column>
          <!--  -->
          <el-table-column prop="exitAmount" label="退费金额"></el-table-column>
          <!-- 新增 -->
          <el-table-column prop="refundreason" label="退费原因"></el-table-column>
          <el-table-column prop="origin" label="来源"></el-table-column>
          <!--  -->
          <el-table-column prop="inputTime" label="添加时间"></el-table-column>
          <el-table-column prop="marketName" label="营销"></el-table-column>

          <el-table-column prop="adviserName" label="顾问"></el-table-column>

          <el-table-column prop="japState" label="资源状态"></el-table-column>
          <el-table-column prop="japanese" label="日语状态"></el-table-column>
          <el-table-column prop="summary" label="跟进情况"></el-table-column>
          <!-- 留学=primary 日语=success 鸣野=warning -->
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-jap="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group v-if="showLimitedOpJap(scope.row)">
                <el-tooltip content="资源详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="japshowstuid=scope.row.id"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="资源详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="japshowstuid=scope.row.id"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditJap(scope.row)">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :size-page="pageSize"
            :page-sizes="[10,20,30,50,100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id>0?'编辑退出资源':''" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-form-item prop="realName" label="姓名" :rules="[{required:true,message:'不能为空'}]">
          <el-input v-model="form.realName" placeholder="请输入姓名"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="资源状态" prop="japState" :rules="[{required:true,message:'不能为空'}]">
              <el-select v-model="form.japState" clearable placeholder="请选择资源状态" filterable>
                <el-option
                  v-for="item in statelist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="退出时间" prop="quitTime" :rules="[{required:true,message:'请选择退出时间'}]">
              <el-date-picker
                v-model="form.quitTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择退出时间"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="refundtime" label="退费课时">
          <el-input type="number" v-model.number="form.refundtime" placeholder="请输入课时"></el-input>
        </el-form-item>
        <el-form-item prop="exitAmount" label="退费金额">
          <el-input-number v-model="form.exitAmount" :precision="2" :min="0" placeholder="请输入退费金额" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item prop="refundreason" label="退费原因">
          <el-input type="area" v-model="form.refundreason" placeholder="请输入原因"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分配弹框（日语板块：可分配留学、鸣野，不显示分配给日语） -->
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserlist"
      :market-list="marketlist"
      :user-is-admain="userIsAdmain"
      :show-student="true"
      :show-jap="false"
      :show-mingye="true"
      name-label="资源名称"
      empty-message="请选择分配给留学或鸣野"
      @success="getList"
    />
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />
    <JapaneseShow :japstuid="japshowstuid" v-on:japsetzero="japshowstuid=0"></JapaneseShow>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import { buildJapSubmitPayload } from "@/plugins/japFormHelper.js";
import JapaneseShow from "@/components/JapaneseShow";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";
import AssignResourceDialog from "@/components/AssignResourceDialog";
export default {
  data() {
    return {
      userIsAdmain: user.isAdmin(), //管理员
      userIsAdviser: user.isAdviser(), //顾问老师
      userIsMarket: user.isMarket(), //营销老师
      query: {state:'f'},
      form: {},
      dialogVisible: false,
      submiting: false,
      loading: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      statelist: url.getStateData(), // 资源状态（与 Common 一致，含 a/b/c/d/e/f/g/s）
      edubacklist: url.getEduBack(), //学历
      studentTypeList: url.getStudentTypeList(), //学生/家长
      provinceList: [], //省份列表
      purposeList: url.getPurposeList(), //学习目的
      intendedFormList: url.getIntendedFormList(), //意向上课形式
      japshowstuid: 0,
      marketlist: [],
      adviserlist: [],
      assignDialogVisible: false, //分配对话框显示
      assignForm: {
        resourceTypes: [] // 分配的资源类型：['鸣野']
      }, //分配表单
      followDialogVisible: false,
      followType: '',
      followDialogRow: null,
    };
  },
  methods: {
    canEditJap(row) {
      return user.canEditJap(row);
    },
    isMarketingOnlyJap(row) {
      return user.isMarketingOnlyJap(row);
    },
    isNoAdviserJap(row) {
      return user.isNoAdviserJap(row);
    },
    showLimitedOpJap(row) {
      return user.showLimitedOpJap(row);
    },
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function(filter) {
      var val = filter[0]["isEnable"];
      this.form.isEnable = val;
      this.getList();
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (_this.query.daterange) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      } else {
        params.start = "";
        params.end = "";
      }
      if (_this.query.quitRange && _this.query.quitRange.length === 2) {
        params.quitStart = _this.query.quitRange[0];
        params.quitEnd = _this.query.quitRange[1];
      } else {
        params.quitStart = "";
        params.quitEnd = "";
      }
      params.state = "f";
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getJap("getlist_base");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 按录入时间查询
    datelClick: function() {
      this.getList();
    },
    // 编辑（列表接口已返回 japState，与后端字段统一，直接拷贝即可）
    editClick: function(row) {
      this.form = Object.assign({}, row);
      if (!this.form.quitTime) {
        var now = new Date();
        var m = now.getMonth() + 1;
        var d = now.getDate();
        this.form.quitTime =
          now.getFullYear() +
          "-" +
          (m < 10 ? "0" + m : m) +
          "-" +
          (d < 10 ? "0" + d : d);
      }
      this.dialogVisible = true;
    },
    // 提交
    submitForm: function(formName) {
      var _this = this;
      var link = url.getJap("addorupdate_base");
      var info = buildJapSubmitPayload(this.form);
      info.studentID = info.studentID || info.StudentID || this.form.studentID;

      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
        // 导出
    exportClick: function() {
      var _this = this;
      var params = Object.assign({}, _this.query);
      if (_this.query.daterange) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      }
      if (_this.query.quitRange && _this.query.quitRange.length === 2) {
        params.quitStart = _this.query.quitRange[0];
        params.quitEnd = _this.query.quitRange[1];
      }
      params.state = "f";
      delete params.daterange;
      delete params.quitRange;
      var result = [];
      for (var item in params) {
        if (params[item] !== undefined && params[item] !== "" && params[item] !== null) {
          result.push(item + "=" + encodeURIComponent(params[item]));
        }
      }
      var link = url.getJap("ExportJapBase") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    showFollowDialog(type, row) {
      this.followType = type;
      this.followDialogRow = row && (row.studentID != null || row.id != null) ? { ...row, id: row.studentID || row.id } : (row || {});
      this.followDialogVisible = true;
    },
    // 分配
    assignClick: function(row) {
      if (!row) return;
      var _this = this;
      _this.assignForm = {
        studentID: row.studentID || row.id,
        realName: row.realName,
        isStudent: row.isStudent || false,
        isJap: row.isJap || false,
        isMingye: row.isMingye || false,
        resourceTypes: [],
        adviserID: row.adviserID || null,
        marketID: row.marketID || null,
        myAdviserID: row.myAdviserID || null,
        myMarketID: row.myMarketID || null
      };
      _this.assignDialogVisible = true;
    },
  },
  components: {
    JapaneseShow,
    OtherDeptFollow,
    FollowDetailDialog,
    AssignResourceDialog,
  },
  mounted() {
    this.getList();
    var _this = this;
    $.get(url.getStu("getenableusers"), {}, data => {
      var list = data || [];
      _this.marketlist = list;
      _this.adviserlist = list;
    });
    $.get(url.getCommon("getareabyname"), {}, data => { _this.provinceList = data || []; });
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>